<template>
    <BaseSection class="board section--wide section--extra-spacing">
        <template
            v-if="title"
            #title
        >
            <h2>{{ title }}</h2>
        </template>

        <section>
            <BannerList
                v-if="offices?.length || sections?.length"
                :items="[...sections, ...offices]"
                :secondary-style="false"
                class="banner--extra-spacing"
            />
        </section>
    </BaseSection>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
        required: false,
        default: 'Board'
    },
    sections: {
        type: Array,
        required: false,
        default: null
    },
    offices: {
        type: Array,
        required: false,
        default: null
    }
});

</script>

<style lang="less">
.board__section {
    display: grid;
    gap: var(--spacing-lg);
    margin-top: var(--spacing-lg);

    @media @q-md-min {
        grid-template-columns: repeat(2, 1fr);
    }

    @media @q-lg-min {
        grid-template-columns: repeat(3, 1fr);
        margin-top: var(--spacing-xl);
        gap: var(--spacing-xl);
    }
}

.board[data-width='2']  .board__section {
    @media @q-lg-min {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>
